"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReferralMessage = getReferralMessage;
exports.hasReferralMatch = hasReferralMatch;
function getReferralMessage(pendingReferrals, clinicianId) {
    const matchedReferral = pendingReferrals === null || pendingReferrals === void 0 ? void 0 : pendingReferrals.find((referral) => referral.userId === clinicianId);
    return matchedReferral === null || matchedReferral === void 0 ? void 0 : matchedReferral.message;
}
function hasReferralMatch(pendingReferrals, clinicianId) {
    const matchedReferral = pendingReferrals === null || pendingReferrals === void 0 ? void 0 : pendingReferrals.find((referral) => referral.userId === clinicianId);
    return !!matchedReferral;
}
